import { BidType } from '../types/auction';
import { TradeState } from '../types/trade';
import ViewType from './viewType';

const segmentConfig = {
  names: {
    paymentsOnHoldListView: 'Payments On Hold List View',
    paymentsOnHoldFilter: 'Payments On Hold Filter',
    paymentsOnHoldSort: 'Payments On Hold Sort',
    paymentsOnHoldViewDocumentsOwing: 'Payments On Hold View Documents Owing',
    viewAlertsList: 'View Alerts List',
    viewTodoList: 'View Todo List',
    pendingSendToNotSoldClicked: 'Pending Send To Not Sold Clicked',
    pendingSendToNotSoldConfirmed: 'Pending Send To Not Sold Confirmed',
    pendingSendToClosingClicked: 'Pending Send to Closing Clicked',
    pendingSendToClosingConfirmed: 'Pending Send to Closing Confirmed',
    pendingParkVehicleClicked: 'Pending Park Vehicle Clicked',
    pendingParkVehicleConfirmed: 'Pending Park Vehicle Confirmed',
    vehicleWatchlisted: 'Vehicle Watchlisted',
    viewQA: 'QA Viewed',
    viewDealerProfilePage: 'View Dealer Profile Page',
    vdpViewed: 'Vdp Viewed',
    vdpCheckTransportInfo: 'VDP Check Transport Info',
    vdpOpenMultimediaGallery: 'VDP Open Multimedia Gallery',
    vdpOverviewImageInteraction: 'VDP Overview Image Interaction',
    vdpClickMultimediaThumbnail: 'VDP Click Multimedia Gallery Thumbnail',
    vdpNavBarNavigation: 'VDP Nav Bar - Navigation',
    pendingAcceptOfferConfirmed: 'Pending Accept Offer Confirmed',
    pendingAcceptOfferClicked: 'Pending Accept Offer Clicked',
    pendingAuctionInDGNClicked: 'Pending Auction in DGN Clicked',
    pendingCounterOfferClicked: 'Pending Counter Offer Clicked',
    pendingDeclineOfferClicked: 'Pending Decline Offer Clicked',
    pendingNegotiateClicked: 'Pending Negotiate Clicked',
    pendingNegotiateConfirmed: 'Pending Negotiate Confirmed',
    pendingStayFirmClicked: 'Pending Stay Firm Clicked',
    pendingStayFirmConfirmed: 'Pending Stay Firm Confirmed',
    pendingViewButtonClicked: 'Pending View Button Clicked',
    pendingDeclineOfferConfirmed: 'Pending Decline Offer Confirmed',
    pendingReplyClicked: 'Pending Reply Clicked',
    pendingErrorMessageShown: 'Pending Error Message Shown',
    pendingUnusedProxyAlertShown: 'Pending Unused Proxy Alert Shown',
    vdpVideoPlayed: 'Vdp Video Played',
    loadListOfTrades: 'Load A List Of Trades',
    networkDropdown: 'Network Dropdown',
    listView: 'List View',
    vdp: 'Vdp',
    watchlist: 'Watchlist',
    marketGuidePriceAnalysisResultsDisplayed:
      'Market Guide Price Analysis Results Displayed',
    savedFilterEmailVdpViewed: 'Saved Filter Email VDP Viewed'
  },
  networkType: {
    open: 'Open Network',
    internal: 'Internal Network',
    all: 'All Networks'
  },
  errorType: {
    cannotEdit: 'Cannot Edit',
    cannotNegoYet: 'Cannot Nego Yet',
    cannotParkOpenTrade: 'Cannot Park Open Trade',
    cannotStartDgnNego: 'Cannot Start Dgn Nego'
  },
  negoOfferType: {
    counterOffer: 'Counter Offer',
    firstOffer: 'First Offer',
    stayFirm: 'Stay Firm'
  },
  sourceSystemType: {
    traderev: 'TR'
  },
  eventStateType: {
    buyPending: 'Buy Pending',
    sellPending: 'Sell Pending'
  },
  eventSourceType: {
    alertsListView: 'Alerts List View',
    paymentsOnHoldListView: 'Payments On Hold List View',
    pendingListView: 'Pending List View',
    pendingVDP: 'Pending Vdp',
    todoListView: 'Todo List View',
    browseListView: 'Browse List View',
    watchlistVdp: 'Watchlist Vdp',
    browseVdp: 'Browse Vdp'
  },
  vdpViewType: {
    fullPage: 'Full Page View',
    sideRail: 'Side Rail View'
  },
  vehicleStatusType: {
    [TradeState.active]: 'In Auction',
    [TradeState.upcoming]: 'In Preview',
    [TradeState.pending]: 'In Negotiation'
  },
  vehicleCardViewType: {
    [ViewType.LIST_VIEW]: 'List View',
    [ViewType.SIDE_RAIL_VIEW]: 'Side Rail View',
    [ViewType.POWER_VIEW]: 'Power View'
  },
  analyticsBidType: {
    [BidType.manual]: '45 Min Bid',
    [BidType.proxy]: '45 Min Proxy',
    [BidType.quickBid]: '45 Min Quick Bid'
  },
  galleryOpenType: {
    button: 'Button',
    damageThumbnails: 'Damage Thumbnails',
    overviewImage: 'Overview Image',
    otherThumbnails: 'Other Thumbnails'
  }
};

export default segmentConfig;
